/* Liviza formulieren: stappen, validatie, pop-ups en meting. Verzending via Shopify-contactformulier. */
(function () {
  if (window.LvForms) { window.LvForms.init(document); return; }

  var MO = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
  var WD = ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'];
  var POPUP_PATHS = { '/pages/adviesgesprek': 'advies', '/pages/showroombezoek': 'showroom', '/pages/club-liviza-partner': 'club' };
  var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'gbraid', 'wbraid', 'fbclid', 'li_fat_id'];

  /* Herkomst bewaren (UTM / klik-id's) voor de hele sessie */
  var attr = {};
  try { attr = JSON.parse(sessionStorage.getItem('lv_lp_attr') || '{}'); } catch (e) {}
  try {
    var q = new URLSearchParams(location.search), changed = false;
    KEYS.forEach(function (k) { var v = q.get(k); if (v) { attr[k] = v; changed = true; } });
    if (!attr.landing) { attr.landing = location.pathname; changed = true; }
    if (changed) sessionStorage.setItem('lv_lp_attr', JSON.stringify(attr));
  } catch (e) {}
  var source = function () { return Object.keys(attr).map(function (k) { return k + '=' + attr[k]; }).join(' | '); };

  var emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var digits = function (s) { return String(s || '').replace(/\D/g, ''); };

  function fieldValid(el) {
    var v = (el.value || '').trim();
    if (el.required && !v) return false;
    if (!v) return true;
    if (el.type === 'email') return emailRe.test(v);
    if (el.type === 'tel') return digits(v).length >= 9;
    if (el.getAttribute('pattern')) { try { return new RegExp('^(?:' + el.getAttribute('pattern') + ')$').test(v); } catch (e) { return true; } }
    return true;
  }
  function mark(wrap, ok) {
    if (!wrap) return;
    wrap.classList.toggle('is-invalid', !ok);
    var err = wrap.querySelector('.lvf-err'); if (err) err.hidden = ok;
  }
  function validate(scope) {
    var first = null;
    scope.querySelectorAll('.lvf-field .lvf-input').forEach(function (el) {
      var ok = fieldValid(el); mark(el.closest('.lvf-field'), ok);
      if (!ok && !first) first = el;
    });
    scope.querySelectorAll('[data-lvf-choice][data-required]').forEach(function (fs) {
      var ok = !!fs.querySelector('input[type=radio]:checked'); mark(fs, ok);
      if (!ok && !first) first = fs.querySelector('input');
    });
    if (first) first.focus({ preventScroll: false });
    return !first;
  }

  function setup(root) {
    if (root.dataset.lvfReady) return;
    root.dataset.lvfReady = '1';
    var form = root.querySelector('form'); if (!form) return;
    form.noValidate = true;
    var type = root.dataset.lvfType, total = parseInt(root.dataset.lvfSteps || '1', 10);
    var cur = parseInt(root.dataset.lvfStart || '1', 10);
    var steps = root.querySelectorAll('[data-lvf-step]');
    var bar2 = root.querySelector('[data-lvf-bar2]'), stepNo = root.querySelector('[data-lvf-stepno]');
    var summary = root.querySelector('[data-lvf-summary]');
    var pageEl = root.querySelector('[data-lvf-page]'); if (pageEl && !pageEl.value) pageEl.value = location.pathname;

    /* Showroom: komende 10 werkdagen */
    var daysBox = root.querySelector('[data-lvf-days]');
    if (daysBox) {
      var d = new Date(); d.setHours(12, 0, 0, 0); var n = 0, html = '';
      while (n < 10) {
        d.setDate(d.getDate() + 1); var w = d.getDay(); if (w === 0 || w === 6) continue;
        var label = WD[w] + ' ' + d.getDate() + ' ' + MO[d.getMonth()];
        var id = (daysBox.dataset.uid || type) + '-dag-' + n;
        html += '<label class="lvf-opt lvf-opt--day"><input type="radio" name="contact[Voorkeursdag]" id="' + id + '" value="' + label + ' ' + d.getFullYear() + '" data-label="' + label + '"' + (n === 0 ? ' required' : '') + '><span class="lvf-opt__box"><small>' + WD[w] + '</small><b>' + d.getDate() + '</b><small>' + MO[d.getMonth()] + '</small></span></label>';
        n++;
      }
      daysBox.innerHTML = html;
    }

    function show(i) {
      cur = i;
      steps.forEach(function (s) { s.hidden = parseInt(s.dataset.lvfStep, 10) !== i; });
      if (bar2) bar2.classList.toggle('is-on', i >= 2);
      if (stepNo) stepNo.textContent = i;
      var focusEl = root.querySelector('[data-lvf-step="' + i + '"] input:not([type=hidden]):not([type=radio]), [data-lvf-step="' + i + '"] textarea');
      if (i > 1 && focusEl && window.matchMedia('(min-width: 601px)').matches) focusEl.focus({ preventScroll: true });
      var box = root.closest('.lvf-modal'); if (box) box.scrollTop = 0;
    }
    function updateSummary() {
      if (!summary) return;
      if (type === 'advies') {
        var c = form.querySelector('input[name="contact[Onderwerp]"]:checked');
        if (c) {
          summary.textContent = c.dataset.label || c.value;
          var ta = form.querySelector('[data-lvf-ph-target]'); if (ta && c.dataset.ph) ta.placeholder = c.dataset.ph;
        }
      } else if (type === 'showroom') {
        var b = form.querySelector('input[name="contact[Branche]"]:checked');
        var dy = form.querySelector('input[name="contact[Voorkeursdag]"]:checked');
        var p = form.querySelector('input[name="contact[Dagdeel]"]:checked');
        summary.textContent = [b && b.value, dy && dy.dataset.label, p && p.value.toLowerCase()].filter(Boolean).join(' · ');
      }
    }
    updateSummary();

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.type === 'radio') {
        mark(t.closest('[data-lvf-choice]'), true);
        updateSummary();
        var fs = t.closest('[data-lvf-choice][data-auto]');
        if (fs && cur < total) setTimeout(function () { show(cur + 1); }, 160);
      }
    });
    root.addEventListener('input', function (e) {
      var w = e.target.closest('.lvf-field');
      if (w && w.classList.contains('is-invalid') && fieldValid(e.target)) mark(w, true);
    });
    root.querySelectorAll('[data-lvf-next]').forEach(function (b) {
      b.addEventListener('click', function () {
        var stepEl = root.querySelector('[data-lvf-step="' + cur + '"]');
        if (validate(stepEl)) { updateSummary(); show(cur + 1); }
      });
    });
    root.querySelectorAll('[data-lvf-back]').forEach(function (b) { b.addEventListener('click', function () { show(1); }); });

    /* Eigen controle in de capture-fase van window, vóór Shopify's CAPTCHA-script. Na validatie en meting
       versturen we opnieuw met requestSubmit, zodat Shopify het CAPTCHA-token toevoegt en zelf verstuurt. */
    form._lvfCheck = function (e) {
      if (form._lvfOk) { form._lvfOk = false; return; }
      e.preventDefault(); e.stopImmediatePropagation();
      var stepEl = root.querySelector('[data-lvf-step="' + cur + '"]') || form;
      if (!validate(stepEl)) return;
      if (!validate(form)) {
        var bad = form.querySelector('.is-invalid'); var s = bad && bad.closest('[data-lvf-step]');
        if (s) show(parseInt(s.dataset.lvfStep, 10));
        return;
      }
      var fn = form.querySelector('[data-lvf-fullname]');
      if (fn) {
        var vn = form.querySelector('[name="contact[Voornaam]"]'), an = form.querySelector('[name="contact[Achternaam]"]');
        fn.value = [vn && vn.value.trim(), an && an.value.trim()].filter(Boolean).join(' ');
      }
      var src = form.querySelector('[data-lvf-source]'); if (src) src.value = source();
      var btn = form.querySelector('button[type=submit]'); if (btn) { btn.disabled = true; btn.dataset.txt = btn.innerHTML; btn.textContent = 'Versturen…'; }
      var br = form.querySelector('input[name="contact[Onderwerp]"]:checked, input[name="contact[Branche]"]:checked, input[name="contact[Interesse]"]:checked, select[name="contact[Branche]"]');
      var done = false, go = function () {
        if (done) return; done = true; form._lvfOk = true;
        if (form.requestSubmit) { form.requestSubmit(); } else { var hb = document.createElement('button'); hb.type = 'submit'; hb.hidden = true; form.appendChild(hb); hb.click(); hb.remove(); }
        setTimeout(function () { if (btn) { btn.disabled = false; btn.innerHTML = btn.dataset.txt; } }, 8000);
      };
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'generate_lead', form_type: type, form_label: root.dataset.lvfLabel || type, branche: br ? br.value : '', page: location.pathname, eventCallback: go, eventTimeout: 1200 });
      } catch (err) {}
      setTimeout(go, 1300);
    };
  }

  /* Pop-ups */
  var lastFocus = null;
  function openModal(kind) {
    var m = document.querySelector('[data-lvf-modal="' + kind + '"]'); if (!m) return false;
    lastFocus = document.activeElement;
    m.hidden = false; m.classList.add('is-open');
    document.documentElement.classList.add('lvf-lock');
    var c = m.querySelector('.lvf-modal__close'); if (c) setTimeout(function () { c.focus(); }, 30);
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'lead_form_open', form_type: kind, page: location.pathname }); } catch (e) {}
    return true;
  }
  function closeModal(m) {
    m.classList.remove('is-open'); m.hidden = true;
    if (!document.querySelector('.lvf-modal.is-open')) document.documentElement.classList.remove('lvf-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var closer = e.target.closest('[data-lvf-close]');
    if (closer) { closeModal(closer.closest('.lvf-modal')); return; }
    var opener = e.target.closest('[data-lvf-open]');
    var kind = opener ? opener.getAttribute('data-lvf-open') : null;
    if (!kind) {
      var a = e.target.closest('a[href]');
      if (a && a.origin === location.origin) kind = POPUP_PATHS[a.pathname.replace(/\/$/, '')];
    }
    if (kind && !e.metaKey && !e.ctrlKey && !e.shiftKey && openModal(kind)) e.preventDefault();
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var m = document.querySelector('.lvf-modal.is-open'); if (m) closeModal(m);
  });

  window.addEventListener('submit', function (e) {
    var f = e.target; if (f && f._lvfCheck) f._lvfCheck(e);
  }, true);

  function init(scope) { (scope || document).querySelectorAll('[data-lvf]').forEach(setup); }
  window.LvForms = { init: init, open: openModal };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
